<template>
    <v-chip variant="outlined" class="ma-1" @click="onClick">
        {{ treatmentComponent.concentration }} {{ getUnitsLabel() }} {{ getTreatmentComponentLabel() }} <v-icon v-if="userCanEditTreatments" class="ms-2" >$pencil</v-icon>
    </v-chip>
</template>
<script setup lang="ts">

import { TreatmentComponentFormConfig, TreatmentComponentSetupConfig } from "@/services/treatments/treatmentsAPI";
import { useAuth } from "@/lib/ts/auth";
import { computed } from "vue";
import { RegistryEntry } from "@/services/registries/registriesAPI";

const { treatmentComponent, registryEntriesForLookups } = defineProps<{
    treatmentComponent: TreatmentComponentSetupConfig;
    registryEntriesForLookups?: TreatmentComponentFormConfig;
}>();

const auth = useAuth();

const userCanEditTreatments = computed(() => {
    return auth.isAuthorized("Treatments:Update");
});

const emit = defineEmits<{
    (e: "onClick"): void;
}>();

function onClick(): void {
    if (userCanEditTreatments.value === true) {
        emit("onClick");
    }
    return;
}

function getUnitsLabel(): string {
    if ("units" in treatmentComponent) {
        const units = treatmentComponent.units as RegistryEntry;
        return units.displayName;
    } else if (registryEntriesForLookups) {
        const unitsRegistryEntry = registryEntriesForLookups.unitsOptions.find((unit) => unit.id === treatmentComponent.unitsRegistryEntryId)!;
        return unitsRegistryEntry.displayName;
    } else {
        return treatmentComponent.unitsRegistryEntryId ?? "???";
    }
}

function getTreatmentComponentLabel(): string {
    if (registryEntriesForLookups) {
        const treatmentComponentRegistryEntry = registryEntriesForLookups.treatmentComponentOptions.find((option) => option.id === treatmentComponent.registryEntryId)!;
        return treatmentComponentRegistryEntry.displayName;
    } else {
        return treatmentComponent.registryEntryId ?? "???";
    }
}

</script>
